/**
 * Build identity of this frontend bundle.
 *
 * The values are baked in at image build time: frontend/Dockerfile turns the
 * VERSION / GIT_COMMIT / BUILD_TIME build-args (calculated by the CI
 * workflows, or scripts/docker-build-push.sh) into VITE_* variables, and Vite
 * inlines them here. A local `pnpm dev` has none of them and shows "dev".
 *
 * VERSION has the same shape the backend reports on /health/live:
 *   tagged release  → 0.1.0
 *   dev build       → 0.1.0-dev.5+abc1234   (the +sha is the same GIT_COMMIT)
 */
const rawVersion = (import.meta.env.VITE_APP_VERSION || '').trim();

/** Version without the `+sha` build metadata (the commit is shown separately). */
export const APP_VERSION = rawVersion.split('+')[0] || 'dev';

/** Short git commit the bundle was built from ('' when unknown). */
export const GIT_COMMIT = (import.meta.env.VITE_GIT_COMMIT || '').trim().replace(/^unknown$/, '');

/** Build time in RFC 3339 ('' when unknown). */
export const BUILD_TIME = (import.meta.env.VITE_BUILD_TIME || '').trim().replace(/^unknown$/, '');

/** `0.1.0-dev.5` → `v0.1.0-dev.5`; a non-numeric marker like `dev` stays as is. */
export function withV(version: string): string {
  return /^\d/.test(version) ? `v${version}` : version;
}

/** `v0.1.0-dev.5 (abc1234)` — what the login page and the sidebar print. */
export function versionLabel(): string {
  const v = withV(APP_VERSION);
  return GIT_COMMIT ? `${v} (${GIT_COMMIT})` : v;
}
